import { action, observable } from 'mobx';
import { adminAccountApi } from '@link/admin/services';
import { ListAdminAccountsStatusEnum } from '@link/admin/services/const';
import { Role } from '@link/share/services/const';
import { ISelectOption } from '@link/share/services/types';

export class Admin {
  @observable accessor salesAccounts: ISelectOption[] = [];
  @observable accessor salesAccountsLoaded = false;

  @action
  async getSalesAccounts() {
    if (this.salesAccountsLoaded) {
      return;
    }

    adminAccountApi
      .listAdminAccounts({
        status: [ListAdminAccountsStatusEnum.On],
        role: [Role.LinkAdmin]
      })
      .then(res => {
        if (res.accounts) {
          this.setSalesAccounts(
            res.accounts.map(account => {
              const loginId = account.loginId || '';
              return { label: loginId, value: loginId };
            })
          );
          this.setSalesAccountsLoaded(true);
        }
      })
      .catch(error => {
        console.error('Failed to fetch sales accounts:', error);
      });
  }

  @action
  setSalesAccounts(accounts: ISelectOption[]) {
    this.salesAccounts = accounts;
  }

  @action
  setSalesAccountsLoaded(loaded: boolean) {
    this.salesAccountsLoaded = loaded;
  }
}

export default new Admin();
